import React, {memo} from "react";
import useProductGroup from "./hook/useProductGroup";
import {ProductGroupProvider} from "./provider";
import PageHeader from "./component/header/index";
import {TableLayout} from "layouts/tableLayout";
import FilterForm from "./component/filter";
import ProductGroupHeader from "./component/table/thead"
import ProductGroupBody from "./component/table/tbody"
import useGlobalContext from "containerContext/storeContext";

const Index = memo(() => {
   const {provider,pagination} = useProductGroup()
   const {state, dispatch} = provider
   const {table} = state
    const [globalState] = useGlobalContext()
    const {user} = globalState
    const isPrincipal = user?.user_type == 2
    

   return (
      <ProductGroupProvider value={{pageState: state, pageDispatch: dispatch}}>
         <PageHeader />
         {/*<SearchProduct/>*/}
         <TableLayout
            header={
               <FilterForm/>
            }
            table={{
               tHead: <ProductGroupHeader isPrincipal={isPrincipal}/>,
               tBody: <ProductGroupBody isPrincipal={isPrincipal}/>,
            }}
            pagination={{
               ...table.pagination,
               onAmountChange: pagination.onAmountChange,
               onPageChange: pagination.onPageChange,
            }}
         />
      </ProductGroupProvider>

   )
})
export default Index